export default "__VITE_ASSET__sskcnVLp__"